import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { PreviewController } from "../../controllers";
import Cookies from "js-cookie";

class Preview extends PreviewController {

  componentDidMount() {
    window.scrollTo(0, 0);
    const token = Cookies.get('acto');
    if(token !== undefined){

      this.props.dispatch(this.getProfile());
    }else{

      window.location.href = `${process.env.REACT_APP_SSO_URL}/`

    }
  }
  render() {
    return (
      <div className="preview">
        <Helmet>
          <title></title>
        </Helmet>
        <div className="preview-content">
          <div className="loader mb-5"></div>
          <p className="content-title">
            در حال انتقال به داشبورد                     </p>
          <p className="content-desc">
            در حال آماده سازی برای انتقال به داشبورد کاربری هستید                        </p>
          <p className="content-desc">
            منتظر بمانید ...                     </p>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  }
};

export default connect(mapStateToProps)(Preview);